import { convertCurrencyToNumber } from 'utils/currencyConverter';
import { TRefinancingDebt } from './refinancing.types';

// A debt "counts" as entered once the user has typed a lender, chosen a
// facility type or entered a balance, so a seeded empty debt doesn't count.
export const hasEnteredDebtData = (debts?: TRefinancingDebt[]): boolean =>
  Boolean(
    debts?.some(
      (debt) =>
        debt?.lenderName?.trim() ||
        Boolean(debt?.facilityType) ||
        debt?.outstandingBalance?.trim(),
    ),
  );

// Round each balance before summing so the total matches the sum of the whole-
// pound debt lines the summary shows.
export const getTotalDebt = (
  debts?: Pick<TRefinancingDebt, 'outstandingBalance'>[],
): number =>
  (debts ?? []).reduce(
    (total, debt) =>
      total +
      Math.round(convertCurrencyToNumber(debt?.outstandingBalance) || 0),
    0,
  );

// Shared by the live Amount-field error and the submit-time schema error.
export const overRequestedAmountMessage = (totalDebt: number): string =>
  `Enter at least £${totalDebt.toLocaleString()} to cover the total debt.`;
